import { render, staticRenderFns } from "./ApplyNumbers.vue?vue&type=template&id=364b6ea3&scoped=true&"
import script from "./ApplyNumbers.vue?vue&type=script&lang=ts&"
export * from "./ApplyNumbers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364b6ea3",
  null
  
)

export default component.exports